import { render } from "./AddQuestionQCMPage.vue?vue&type=template&id=bb509f70&ts=true"
import script from "./AddQuestionQCMPage.vue?vue&type=script&lang=ts"
export * from "./AddQuestionQCMPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__